/* v6: v4 QuantityBreaks/QuantityBreakUpsells selection + v4 multi-item intent,
   adapted to Dawn's existing DBCommerce queue. No independent transport. */
(() => {
  if (window.DBPurchaseExtensions) return;
  const parse = root => { try { return JSON.parse(root.querySelector('script[type="application/json"]')?.textContent || '[]'); } catch { return []; } };
  const values = root => [...root.querySelectorAll('select')].map(s => s.value);
  const find = (variants, selected) => variants.find(v => selected.every((value, i) => String(v.options?.[i]) === String(value)));
  const infoFor = form => form.closest('product-info') || form.closest('.product__info-container') || form.closest('.shopify-section');
  const money = (n, fmt) => window.Shopify?.formatMoney ? Shopify.formatMoney(n, fmt) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:JSON.parse(document.getElementById('DBCommerceConfig')?.textContent || '{}').currency || 'USD' }).format(n / 100);
  class DawnBuyButtons extends HTMLElement {
    connectedCallback() {
      if (this.dataset.quantityAppendBound === 'true') return;
      const position = this.dataset.atcAppend;
      if (!['left', 'right'].includes(position)) return;
      const sectionId = this.dataset.sectionId;
      const productInfo = this.closest('product-info');
      const quantity = productInfo?.querySelector(`#Quantity-Form-${sectionId}`);
      const buttons = this.querySelector('.product-form__buttons');
      const primary = this.querySelector(`#ProductSubmitButton-${sectionId}`);
      if (!quantity || !buttons || !primary || quantity.closest('.product-form__quantity-and-btn')) return;

      const group = document.createElement('div');
      group.className = `product-form__quantity-and-btn product-form__quantity-and-btn--${position} product-form__quantity-and-btn--${this.dataset.atcAppendHeights || 'original'}`;
      primary.parentNode.insertBefore(group, primary);
      if (position === 'left') {
        group.append(quantity, primary);
      } else {
        group.append(primary, quantity);
      }
      this.dataset.quantityAppendBound = 'true';
    }
  }
  customElements.define('dawn-buy-buttons', DawnBuyButtons);
  class QuantityBreakUpsells extends HTMLElement {
    connectedCallback() {
      if (this.bound) return; this.bound = true;
      this.querySelectorAll('[data-toggle="true"]').forEach(item => {
        item.setAttribute('role','checkbox'); item.tabIndex = 0;
        const change = event => {
          if (event.type === 'keydown' && ![' ', 'Enter'].includes(event.key)) return;
          if (event.target.closest('select,a,button')) return;
          event.preventDefault();
          item.dataset.selected = String(item.dataset.selected !== 'true');
          item.setAttribute('aria-checked',item.dataset.selected);
          // The source repeats each slot across offers: explicit intent applies to that slot.
          const slot = item.dataset.additionalKey.split('-').pop();
          this.closest('v6-quantity-breaks')?.querySelectorAll('[data-toggle="true"][data-additional-key]').forEach(other => {
            if (other.dataset.additionalKey.split('-').pop() === slot) { other.dataset.selected=item.dataset.selected; other.setAttribute('aria-checked',item.dataset.selected); }
          });
          this.dispatchEvent(new CustomEvent('upsell:change',{bubbles:true,detail:{item,selected:item.dataset.selected==='true'}}));
        };
        item.setAttribute('aria-checked',item.dataset.selected);
        item.addEventListener('click',change); item.addEventListener('keydown',change);
      });
    }
  }
  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.planChangeHandler ||= event => { if (['selling_plan','id'].includes(event.target.name) && event.target.form?.getAttribute('id') === this.dataset.form) this.updatePrices(); };
      document.addEventListener('change', this.planChangeHandler);
      if (this.bound) { this.updatePrices(); return; } this.bound=true; this.variants=parse(this);
      this.addEventListener('change',event => {
        if (event.target.matches('input[type=radio]')) this.applyQuantity(event.target);
        if (event.target.matches('select')) { this.updateOfferVariant(event.target.closest('.quantity-break__selector-item')); this.updatePrices(); }
      });
      let selected=this.querySelector('input[type=radio]:checked') || this.querySelector('input[type=radio]');
      if (selected) { selected.checked=true; this.applyQuantity(selected); }
      this.querySelectorAll('.quantity-break__selector-item').forEach(row=>this.updateOfferVariant(row));
      this.updatePrices();
    }
    disconnectedCallback() { document.removeEventListener('change', this.planChangeHandler); }
    applyQuantity(input) {
      const amount=Number(input.value || 1), index=input.dataset.index;
      const form=document.getElementById(this.dataset.form);
      // Keep Dawn quantity rules/quantity-gift listeners in sync without duplicate quantity radios.
      const field=[...(form?.elements || [])].find(e=>e.name==='quantity' && e.type!=='radio');
      if (field && Number(field.value)!==amount) { field.value=amount;field.dispatchEvent(new Event('change',{bubbles:true})); }
      this.querySelectorAll('v6-quantity-break-upsells').forEach(u=>{const active=u.dataset.offer===index;u.dataset.active=String(active);u.hidden=this.dataset.hideOtherOffers!=='false' && !active;});
      this.dispatchEvent(new CustomEvent('quantity-break:change',{bubbles:true,detail:{quantity:amount,input,section:this.dataset.section,preventGalleryScroll:this.dataset.preventGalleryScroll==='true'}}));
    }
    updateOfferVariant(row) {
      if (!row) return;
      const selects=[...row.querySelectorAll('select')];
      const syncOptions=()=>selects.forEach((select,index)=>[...select.options].forEach(option=>{
        const candidates=this.variants.filter(v=>String(v.options?.[index])===option.value && selects.slice(0,index).every((previous,i)=>String(v.options?.[i])===previous.value));
        option.disabled=candidates.length===0 || (this.dataset.skipUnavailable==='true' && !candidates.some(v=>v.available));
        option.hidden=option.disabled;
      }));
      syncOptions();
      let variant=find(this.variants,values(row));
      // Source resolveSelectableVariant behavior: configured skip-unavailable selects first sellable variant.
      if ((!variant || !variant.available) && this.dataset.skipUnavailable==='true') {
        variant=this.variants.find(v=>v.available);
        if (variant) { row.querySelectorAll('select').forEach((s,i)=>s.value=variant.options[i]); syncOptions(); }
      }
      row.dataset.selectedId=variant?.id || ''; row.dataset.available=String(!!variant?.available);
      row.querySelectorAll('select').forEach(s=>s.setAttribute('aria-invalid',String(!variant?.available)));
      const image=row.querySelector('img'), src=variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
      if (image && src) image.src=src;
    }
    discount(price,label) {
      const percentageLeft=Math.min(1,Math.max(0,Number(label?.dataset.percentageLeft ?? 1)));
      const fixedDiscount=Math.max(0,Number(label?.dataset.fixedDiscount || 0));
      return Math.max(0,Math.round(Number(price || 0)*percentageLeft-fixedDiscount));
    }
    updatePrices() {
      if (this.dataset.updatePrices!=='true') return;
      const form=document.getElementById(this.dataset.form);
      const plan=form ? String(new FormData(form).get('selling_plan') || '') : '';
      let allocations={};try { allocations=JSON.parse(this.querySelector('[data-v6-selling-plans]')?.textContent || '{}'); } catch {}
      const actualPrice=v=>{const price=allocations[String(v.id)]?.prices?.[plan];return plan && Number.isFinite(price)?price:Number(v.price);};
      const selectedVariant=this.variants.find(v=>String(v.id)===String(form && new FormData(form).get('id')));
      let selectedPrice=null,selectedComparePrice=null;
      this.querySelectorAll('label.quantity-break').forEach(label=>{
        const rows=[...label.querySelectorAll('.quantity-break__selector-item')],q=Number(label.dataset.quantity);
        const variants=rows.map(row=>this.variants.find(v=>String(v.id)===row.dataset.selectedId));
        if (variants.some(v=>!v)) return;
        const rawPrice=rows.length?variants.reduce((s,v)=>s+actualPrice(v),0):(selectedVariant?actualPrice(selectedVariant):Number(this.dataset.basePrice))*q;
        const rawCompare=rows.length?variants.reduce((s,v)=>s+Math.max(actualPrice(v),label.dataset.compareMode==='compare_price'?Number(v.compare_at_price||0):Number(v.price)),0):Number(label.dataset.baseComparePrice)*q;
        const price=this.discount(rawPrice,label);
        const compare=Math.max(price,this.discount(rawCompare,label));
        const saved=compare-price;
        const replacements={quantity:q,price:money(price,this.dataset.moneyFormat),compare_price:money(compare,this.dataset.moneyFormat),amount_saved:money(saved,this.dataset.moneyFormat),amount_saved_rounded:money(Math.round(saved/100)*100,this.dataset.moneyFormat),price_each:money(price/q,this.dataset.moneyFormat),compare_price_each:money(compare/q,this.dataset.moneyFormat),percentage_saved:compare?Math.round(saved/compare*100)+'%':'0%'};
        label.querySelectorAll('[data-text]').forEach(node=>{node.innerHTML=node.dataset.text.replace(/\[([a-z_]+)\]/g,(token,key)=>key in replacements?String(replacements[key]):token);});
        const input=this.querySelector(`input[type=radio][data-index="${CSS.escape(label.dataset.index || '')}"]`);
        if (input?.checked) { selectedPrice=price;selectedComparePrice=compare; }
      });
      if (this.dataset.updatePdpPrices==='true' && Number.isFinite(selectedPrice)) {
        this.dispatchEvent(new CustomEvent('quantity-break:price-change',{bubbles:true,detail:{price:selectedPrice,comparePrice:selectedComparePrice,amountSaved:selectedComparePrice-selectedPrice,percentageSaved:selectedComparePrice?Math.round((selectedComparePrice-selectedPrice)/selectedComparePrice*100)+'%':'0%'}}));
      }
    }
    items(form) {
      const input=this.querySelector('input[type=radio]:checked');
      if (!input) throw Error('Choose a quantity offer.');
      const label=this.querySelector(`label[for="${CSS.escape(input.id)}"]`),quantity=Number(input.value);
      if (!Number.isInteger(quantity)||quantity<1) throw Error('Choose a valid quantity.');
      const rows=[...label.querySelectorAll('.quantity-break__selector-item')];
      const chosen=rows.length?rows.map(row=>this.variants.find(v=>String(v.id)===row.dataset.selectedId)):[this.variants.find(v=>String(v.id)===String(new FormData(form).get('id')))];
      if (chosen.some(v=>!v?.available)) throw Error('Choose an available variant for every item in the offer.');
      if (rows.length && rows.length!==quantity) throw Error('The offer quantity does not match its variant selectors.');
      const plan = String(new FormData(form).get('selling_plan') || '');
      let allocations = {};
      try { allocations = JSON.parse(this.querySelector('[data-v6-selling-plans]')?.textContent || '{}'); } catch { throw Error('Subscription information could not be read.'); }
      for (const variant of chosen) {
        const allocation = allocations[String(variant.id)];
        const plans = allocation?.plans || variant.selling_plan_allocations?.map(a=>String(a.selling_plan?.id));
        if ((plan && (!plans || !plans.includes(plan))) || (!plan && allocation?.required)) throw Error('Choose a selling plan available for every selected variant, or use compatible variants.');
      }
      const grouped=new Map();chosen.forEach(v=>grouped.set(String(v.id),(grouped.get(String(v.id))||0)+(rows.length?1:quantity)));
      return [...grouped].map(([id,q])=>{
        const rule=this.variants.find(v=>String(v.id)===id).quantity_rule;
        if(rule && (q<rule.min||(rule.max!=null && q>rule.max)||q%(rule.increment||1)!==0)) throw Error('The offer does not meet this variant’s quantity rules.');
        return {id,quantity:q};
      });
    }
  }
  customElements.define('v6-quantity-break-upsells',QuantityBreakUpsells);
  customElements.define('v6-quantity-breaks',QuantityBreaks);
  const additional=(host,form)=>{
    if(host.dataset.v6Bundle==='true' && host.dataset.includePdpUpsells!=='true')return [];
    const info=infoFor(form);if(!info)return [];
    const parent=info.dataset.productId || info.querySelector('[data-product-id]')?.dataset.productId || '';
    const items=[];
    if(host.dataset.v6Bundle!=='true') info.querySelectorAll('v4-bundle-deals[data-v6-main-bundle=true]').forEach(bundle=>{
      bundle.querySelectorAll('.bundle-deals__checkbox-js:checked:not(:disabled)').forEach(row=>items.push({id:row.dataset.id,quantity:1,scope:'source',key:bundle.dataset.sourceKey+'-'+row.dataset.index,properties:{_theme_upsell_key:bundle.dataset.sourceKey+'-'+row.dataset.index}}));
    });
    info.querySelectorAll('v6-quantity-break-upsells:not([data-active=false]):not([hidden]) [data-additional-key][data-product][data-selected=true]').forEach(row=>items.push({id:row.dataset.product,quantity:1,key:row.dataset.additionalKey,scope:'source',properties:{_theme_additional_key:row.dataset.additionalKey,_theme_parent_product_id:parent,_theme_min_parent_quantity:row.dataset.minQuantity||'1',_theme_additional_kind:row.dataset.type||'upsell'}}));
    return items;
  };
  const capture=(host,form)=>{
    if(host.dataset.v4Bundle==='true')return null;
    const tier=infoFor(form)?.querySelector('v6-quantity-breaks');
    if(!tier)return null;
    return tier.items(form);
  };
  window.DBPurchaseExtensions={capture,additional};
})();
